import { defineManifest } from "@tc/sdk";
export const manifest = defineManifest({
    id: "promotions",
    name: "Promotions",
    version: "0.1.0",
    tier: "addon",
    accent: "promotions",
    dependsOn: ["sites"],
    description: "Plan each promotion period from the wholesaler's deals: pick the lines, set the prices and multibuys, check the margins, lay out the gondola ends and publish. Stores see what's on, what's coming and what's ending, download the list, and tick off when everything is up.",
    permissions: {
        view: "See the promotions for your sites and tick them off as up",
        manage: "Plan periods, upload the wholesaler's deals, build and publish the promotions",
        settings: "Promotion dates, margin floor, gondola ends and member-deal sites",
    },
    grants: {
        "Head office": ["view", "manage", "settings"],
        "Area manager": ["view"],
        "Site manager": ["view"],
        "Supervisor": ["view"],
    },
    tasks: [
        { key: "put-up", title: "Put the promotions up", description: "A new promotion period starts at your site: labels, ends and point of sale. Clears when the site ticks it off.", level: "action", audience: "sites", clear: "fix", link: "/promotions", icon: "tag", sort: 10 },
        { key: "publish", title: "Promotions to publish", description: "A period starts soon and its promotions haven't been published to the stores. Clears when they're published.", level: "action", audience: "routed", clear: "fix", link: "/promotions/plan", icon: "broadcast", sort: 20, notify: false },
    ],
    widgets: [
        { key: "now", title: "Promotions", description: "What's on now, what's next, and whether your sites have put them up.", group: "Shop", size: 1, permission: "view", defaultOn: false, order: 76 },
    ],
    nav: [
        // For the sites: the offers running at your site, and what goes on each gondola end (Jamie's phone review, 22/10/26).
        { label: "Promotions", path: "/promotions", section: "shop", tab: "Promotions", tabIcon: "sparkle", permission: "view", icon: "tag", order: 30, blurb: "The offers at your site: search, filter, pictures; tick them off" },
        { label: "Promotion ends", path: "/promotions/ends", section: "shop", tab: "Promotions", tabIcon: "sparkle", permission: "view", icon: "grid", order: 32, blurb: "What goes on each gondola end, with the deal, price and barcode" },
        // Head office's setup (the planner with the Co-op calendar reader and the settings, and laying out the ends) lives in
        // the Shop's settings, out of the sites' way.
        { label: "Promotion planner", path: "/promotions/plan", section: "shop", kind: "settings", permission: "manage", icon: "calendar", order: 31, blurb: "Plan each period, read the Co-op calendar, set the rules" },
        { label: "Lay out the ends", path: "/promotions/layout", section: "shop", kind: "settings", permission: "manage", icon: "grid", order: 32.5, blurb: "Which deals go on each gondola end, shelf by shelf" },
    ],
});
